/**
 * this files contains all routes including the names and the links
 *
 *
 * Created by Tom on 23/05/18
 */

import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import { withRouter, Switch } from 'react-router-dom'

import Dashboard from './pages/Dashboard/'
import Account from './pages/Account'
import Fund from './pages/Fund'
import Documents from './pages/Documents'
import Billing from './pages/Billing'

const Routes = (props) => {
    return (
        <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/account" component={Account} />
            <Route exact path="/myfund" component={Fund} />
            <Route exact path="/documents" component={Documents} />
            <Route exact path="/billing" component={Billing} />
        </Switch>
    )
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        //isAuthenticated: state.user.isAuthenticated
    }
}

export default withRouter(connect(mapStateToProps)(Routes))



// WEBPACK FOOTER //
// ./src/routes.js